import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';

import { API_BASE_URL as baseUrl } from 'src/utils/api-url';
const resource = 'user-role';

/** POST /list：后端要求 email 与 wallet_address 必须且只能填其一 */
export type UserRoleListRequest =
  | { email: string; wallet_address?: never }
  | { email?: never; wallet_address: string };

export type UserRoleListUser = {
  user_id?: string;
  email?: string;
  wallet_address?: string;
  roles?: string[];
};

export type UserRoleIdentifier =
  | { user_id: string; email?: never; wallet_address?: never }
  | { user_id?: never; email: string; wallet_address?: never }
  | { user_id?: never; email?: never; wallet_address: string };

async function authHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };
}

export async function roleList() {
  const url = `${baseUrl}/${resource}/roles`;
  return axios.get<{ roles: string[] }>(url, { headers: await authHeaders() });
}

/** 将接口返回规范为「用户行」列表，兼容多种返回结构 */
export function normalizeUserRoleListResponse(data: Record<string, unknown> | undefined, inputs: { userId: string; email: string; wallet: string }): UserRoleListUser[] {
  if (!data || typeof data !== 'object') return [];
  const users = data.users;
  if (Array.isArray(users)) {
    return users.map((u) => (u && typeof u === 'object' ? (u as UserRoleListUser) : {}));
  }
  const single = data.user;
  if (single && typeof single === 'object') {
    return [single as UserRoleListUser];
  }
  if (
    data.roles !== undefined ||
    inputs.userId !== undefined ||
    inputs.email !== undefined ||
    inputs.wallet !== undefined
  ) {
    return [
      {
        user_id: inputs.userId as string | undefined,
        email: inputs.email as string | undefined,
        wallet_address: inputs.wallet as string | undefined,
        roles: Array.isArray(data.roles) ? (data.roles as string[]) : undefined,
      },
    ];
  }
  return [];
}

export async function userRoleList(identifier: UserRoleListRequest) {
  const url = `${baseUrl}/${resource}/list`;
  return axios.post<Record<string, unknown>>(url, identifier, { headers: await authHeaders() });
}

export async function addUserRole(payload: UserRoleIdentifier & { role: string }) {
  const url = `${baseUrl}/${resource}/add`;
  return axios.post<{ success: boolean; message: string }>(url, payload, {
    headers: await authHeaders(),
  });
}
